module.exports = "<contractor-page></contractor-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/contractor.html
// module id = 2014
// module chunks = 0